/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import type { Prisma, FileAccessControl } from ".zenstack/models";
import type { UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { getHooksContext } from '@zenstackhq/tanstack-query/runtime-v5/react';
import { useModelQuery, useInfiniteModelQuery, useModelMutation } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { PickEnumerable, CheckSelect, QueryError, ExtraQueryOptions, ExtraMutationOptions } from '@zenstackhq/tanstack-query/runtime-v5';
import type { PolicyCrudKind } from '@zenstackhq/runtime'
import metadata from './__model_meta';
type DefaultError = QueryError;
import { useSuspenseModelQuery, useSuspenseInfiniteModelQuery } from '@zenstackhq/tanstack-query/runtime-v5/react';
import type { UseSuspenseQueryOptions, UseSuspenseInfiniteQueryOptions } from '@tanstack/react-query';

export function useCreateFileAccessControl(options?: Omit<(UseMutationOptions<(FileAccessControl | undefined), DefaultError, Prisma.FileAccessControlCreateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.FileAccessControlCreateArgs, DefaultError, FileAccessControl, true>('FileAccessControl', 'POST', `${endpoint}/fileAccessControl/create`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.FileAccessControlCreateArgs>(
            args: Prisma.SelectSubset<T, Prisma.FileAccessControlCreateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, FileAccessControl, Prisma.FileAccessControlGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.FileAccessControlCreateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, FileAccessControl, Prisma.FileAccessControlGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useCreateManyFileAccessControl(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.FileAccessControlCreateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.FileAccessControlCreateManyArgs, DefaultError, Prisma.BatchPayload, false>('FileAccessControl', 'POST', `${endpoint}/fileAccessControl/createMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.FileAccessControlCreateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.FileAccessControlCreateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.FileAccessControlCreateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useFindManyFileAccessControl<TArgs extends Prisma.FileAccessControlFindManyArgs, TQueryFnData = Array<Prisma.FileAccessControlGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.FileAccessControlFindManyArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('FileAccessControl', `${endpoint}/fileAccessControl/findMany`, args, options, fetch);
}

export function useInfiniteFindManyFileAccessControl<TArgs extends Prisma.FileAccessControlFindManyArgs, TQueryFnData = Array<Prisma.FileAccessControlGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.FileAccessControlFindManyArgs>, options?: Omit<UseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useInfiniteModelQuery<TQueryFnData, TData, TError>('FileAccessControl', `${endpoint}/fileAccessControl/findMany`, args, options, fetch);
}

export function useSuspenseFindManyFileAccessControl<TArgs extends Prisma.FileAccessControlFindManyArgs, TQueryFnData = Array<Prisma.FileAccessControlGetPayload<TArgs> & { $optimistic?: boolean }>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.FileAccessControlFindManyArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('FileAccessControl', `${endpoint}/fileAccessControl/findMany`, args, options, fetch);
}

export function useSuspenseInfiniteFindManyFileAccessControl<TArgs extends Prisma.FileAccessControlFindManyArgs, TQueryFnData = Array<Prisma.FileAccessControlGetPayload<TArgs>>, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.FileAccessControlFindManyArgs>, options?: Omit<UseSuspenseInfiniteQueryOptions<TQueryFnData, TError, InfiniteData<TData>>, 'queryKey' | 'initialPageParam'>) {
    options = options ?? { getNextPageParam: () => null };
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseInfiniteModelQuery<TQueryFnData, TData, TError>('FileAccessControl', `${endpoint}/fileAccessControl/findMany`, args, options, fetch);
}

export function useFindUniqueFileAccessControl<TArgs extends Prisma.FileAccessControlFindUniqueArgs, TQueryFnData = Prisma.FileAccessControlGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.FileAccessControlFindUniqueArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('FileAccessControl', `${endpoint}/fileAccessControl/findUnique`, args, options, fetch);
}

export function useSuspenseFindUniqueFileAccessControl<TArgs extends Prisma.FileAccessControlFindUniqueArgs, TQueryFnData = Prisma.FileAccessControlGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.FileAccessControlFindUniqueArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('FileAccessControl', `${endpoint}/fileAccessControl/findUnique`, args, options, fetch);
}

export function useFindFirstFileAccessControl<TArgs extends Prisma.FileAccessControlFindFirstArgs, TQueryFnData = Prisma.FileAccessControlGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.FileAccessControlFindFirstArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('FileAccessControl', `${endpoint}/fileAccessControl/findFirst`, args, options, fetch);
}

export function useSuspenseFindFirstFileAccessControl<TArgs extends Prisma.FileAccessControlFindFirstArgs, TQueryFnData = Prisma.FileAccessControlGetPayload<TArgs> & { $optimistic?: boolean }, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.FileAccessControlFindFirstArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('FileAccessControl', `${endpoint}/fileAccessControl/findFirst`, args, options, fetch);
}

export function useUpdateFileAccessControl(options?: Omit<(UseMutationOptions<(FileAccessControl | undefined), DefaultError, Prisma.FileAccessControlUpdateArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.FileAccessControlUpdateArgs, DefaultError, FileAccessControl, true>('FileAccessControl', 'PUT', `${endpoint}/fileAccessControl/update`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.FileAccessControlUpdateArgs>(
            args: Prisma.SelectSubset<T, Prisma.FileAccessControlUpdateArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, FileAccessControl, Prisma.FileAccessControlGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.FileAccessControlUpdateArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, FileAccessControl, Prisma.FileAccessControlGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useUpdateManyFileAccessControl(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.FileAccessControlUpdateManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.FileAccessControlUpdateManyArgs, DefaultError, Prisma.BatchPayload, false>('FileAccessControl', 'PUT', `${endpoint}/fileAccessControl/updateMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.FileAccessControlUpdateManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.FileAccessControlUpdateManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.FileAccessControlUpdateManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useUpsertFileAccessControl(options?: Omit<(UseMutationOptions<(FileAccessControl | undefined), DefaultError, Prisma.FileAccessControlUpsertArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.FileAccessControlUpsertArgs, DefaultError, FileAccessControl, true>('FileAccessControl', 'POST', `${endpoint}/fileAccessControl/upsert`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.FileAccessControlUpsertArgs>(
            args: Prisma.SelectSubset<T, Prisma.FileAccessControlUpsertArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, FileAccessControl, Prisma.FileAccessControlGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.FileAccessControlUpsertArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, FileAccessControl, Prisma.FileAccessControlGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeleteFileAccessControl(options?: Omit<(UseMutationOptions<(FileAccessControl | undefined), DefaultError, Prisma.FileAccessControlDeleteArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.FileAccessControlDeleteArgs, DefaultError, FileAccessControl, true>('FileAccessControl', 'DELETE', `${endpoint}/fileAccessControl/delete`, metadata, options, fetch, true)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.FileAccessControlDeleteArgs>(
            args: Prisma.SelectSubset<T, Prisma.FileAccessControlDeleteArgs>,
            options?: Omit<(UseMutationOptions<(CheckSelect<T, FileAccessControl, Prisma.FileAccessControlGetPayload<T>> | undefined), DefaultError, Prisma.SelectSubset<T, Prisma.FileAccessControlDeleteArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as (CheckSelect<T, FileAccessControl, Prisma.FileAccessControlGetPayload<T>> | undefined);
        },
    };
    return mutation;
}

export function useDeleteManyFileAccessControl(options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.FileAccessControlDeleteManyArgs> & ExtraMutationOptions), 'mutationFn'>) {
    const { endpoint, fetch } = getHooksContext();
    const _mutation =
        useModelMutation<Prisma.FileAccessControlDeleteManyArgs, DefaultError, Prisma.BatchPayload, false>('FileAccessControl', 'DELETE', `${endpoint}/fileAccessControl/deleteMany`, metadata, options, fetch, false)
        ;
    const mutation = {
        ..._mutation,
        mutateAsync: async <T extends Prisma.FileAccessControlDeleteManyArgs>(
            args: Prisma.SelectSubset<T, Prisma.FileAccessControlDeleteManyArgs>,
            options?: Omit<(UseMutationOptions<Prisma.BatchPayload, DefaultError, Prisma.SelectSubset<T, Prisma.FileAccessControlDeleteManyArgs>> & ExtraMutationOptions), 'mutationFn'>
        ) => {
            return (await _mutation.mutateAsync(
                args,
                options as any
            )) as Prisma.BatchPayload;
        },
    };
    return mutation;
}

export function useAggregateFileAccessControl<TArgs extends Prisma.FileAccessControlAggregateArgs, TQueryFnData = Prisma.GetFileAccessControlAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.FileAccessControlAggregateArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('FileAccessControl', `${endpoint}/fileAccessControl/aggregate`, args, options, fetch);
}

export function useSuspenseAggregateFileAccessControl<TArgs extends Prisma.FileAccessControlAggregateArgs, TQueryFnData = Prisma.GetFileAccessControlAggregateType<TArgs>, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.FileAccessControlAggregateArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('FileAccessControl', `${endpoint}/fileAccessControl/aggregate`, args, options, fetch);
}

export function useGroupByFileAccessControl<TArgs extends Prisma.FileAccessControlGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.FileAccessControlGroupByArgs['orderBy'] } : { orderBy?: Prisma.FileAccessControlGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.FileAccessControlGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.FileAccessControlGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.FileAccessControlGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.FileAccessControlGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.FileAccessControlGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('FileAccessControl', `${endpoint}/fileAccessControl/groupBy`, args, options, fetch);
}

export function useSuspenseGroupByFileAccessControl<TArgs extends Prisma.FileAccessControlGroupByArgs, HasSelectOrTake extends Prisma.Or<Prisma.Extends<'skip', Prisma.Keys<TArgs>>, Prisma.Extends<'take', Prisma.Keys<TArgs>>>, OrderByArg extends Prisma.True extends HasSelectOrTake ? { orderBy: Prisma.FileAccessControlGroupByArgs['orderBy'] } : { orderBy?: Prisma.FileAccessControlGroupByArgs['orderBy'] }, OrderFields extends Prisma.ExcludeUnderscoreKeys<Prisma.Keys<Prisma.MaybeTupleToUnion<TArgs['orderBy']>>>, ByFields extends Prisma.MaybeTupleToUnion<TArgs['by']>, ByValid extends Prisma.Has<ByFields, OrderFields>, HavingFields extends Prisma.GetHavingFields<TArgs['having']>, HavingValid extends Prisma.Has<ByFields, HavingFields>, ByEmpty extends TArgs['by'] extends never[] ? Prisma.True : Prisma.False, InputErrors extends ByEmpty extends Prisma.True
    ? `Error: "by" must not be empty.`
    : HavingValid extends Prisma.False
    ? {
        [P in HavingFields]: P extends ByFields
        ? never
        : P extends string
        ? `Error: Field "${P}" used in "having" needs to be provided in "by".`
        : [
            Error,
            'Field ',
            P,
            ` in "having" needs to be provided in "by"`,
        ]
    }[HavingFields]
    : 'take' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "take", you also need to provide "orderBy"'
    : 'skip' extends Prisma.Keys<TArgs>
    ? 'orderBy' extends Prisma.Keys<TArgs>
    ? ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields]
    : 'Error: If you provide "skip", you also need to provide "orderBy"'
    : ByValid extends Prisma.True
    ? {}
    : {
        [P in OrderFields]: P extends ByFields
        ? never
        : `Error: Field "${P}" in "orderBy" needs to be provided in "by"`
    }[OrderFields], TQueryFnData = {} extends InputErrors ?
    Array<PickEnumerable<Prisma.FileAccessControlGroupByOutputType, TArgs['by']> &
    {
        [P in ((keyof TArgs) & (keyof Prisma.FileAccessControlGroupByOutputType))]: P extends '_count'
        ? TArgs[P] extends boolean
        ? number
        : Prisma.GetScalarType<TArgs[P], Prisma.FileAccessControlGroupByOutputType[P]>
        : Prisma.GetScalarType<TArgs[P], Prisma.FileAccessControlGroupByOutputType[P]>
    }
    > : InputErrors, TData = TQueryFnData, TError = DefaultError>(args: Prisma.SelectSubset<TArgs, Prisma.SubsetIntersection<TArgs, Prisma.FileAccessControlGroupByArgs, OrderByArg> & InputErrors>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('FileAccessControl', `${endpoint}/fileAccessControl/groupBy`, args, options, fetch);
}

export function useCountFileAccessControl<TArgs extends Prisma.FileAccessControlCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.FileAccessControlCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.FileAccessControlCountArgs>, options?: (Omit<UseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<TQueryFnData, TData, TError>('FileAccessControl', `${endpoint}/fileAccessControl/count`, args, options, fetch);
}

export function useSuspenseCountFileAccessControl<TArgs extends Prisma.FileAccessControlCountArgs, TQueryFnData = TArgs extends { select: any; } ? TArgs['select'] extends true ? number : Prisma.GetScalarType<TArgs['select'], Prisma.FileAccessControlCountAggregateOutputType> : number, TData = TQueryFnData, TError = DefaultError>(args?: Prisma.SelectSubset<TArgs, Prisma.FileAccessControlCountArgs>, options?: (Omit<UseSuspenseQueryOptions<TQueryFnData, TError, TData>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useSuspenseModelQuery<TQueryFnData, TData, TError>('FileAccessControl', `${endpoint}/fileAccessControl/count`, args, options, fetch);
}

export function useCheckFileAccessControl<TError = DefaultError>(args: { operation: PolicyCrudKind; where?: { createdById?: string; updatedById?: string; deletedById?: string; id?: string; fileId?: string; userId?: string }; }, options?: (Omit<UseQueryOptions<boolean, TError, boolean>, 'queryKey'> & ExtraQueryOptions)) {
    const { endpoint, fetch } = getHooksContext();
    return useModelQuery<boolean, boolean, TError>('FileAccessControl', `${endpoint}/fileAccessControl/check`, args, options, fetch);
}
